import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-lider-de-planificacion',
  templateUrl: './menu-lider-de-planificacion.component.html',
  styleUrls: ['./menu-lider-de-planificacion.component.scss']
})
export class MenuLiderDePlanificacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
